import {Component, EventEmitter, HostBinding, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormControl} from '@angular/forms';
import {combineLatest, Observable, Subscription} from 'rxjs';
import {Router} from '@angular/router';
import {StatisticsSelectionService} from '../statistics-selection-service/statistics-selection.service';
import {AuthorizationService} from '../../authorization/authorization.service';
import {distinctUntilChanged, filter, map, withLatestFrom} from 'rxjs/operators';
import {StatisticSelectionData} from './statistic-selection-data';

@Component({
  selector: 'app-statistic-selection',
  templateUrl: './statistic-selection.component.html',
  styleUrls: ['./statistic-selection.component.scss']
})
export class StatisticSelectionComponent implements OnInit, OnDestroy {
  @HostBinding('class.grid-tools__filter-container') statisticSelectionComponentContainer = true;
  @Input() showRegionSelection = true;
  @Input() showUnitTypes = true;
  @Output() selection: EventEmitter<StatisticSelectionData> = new EventEmitter<StatisticSelectionData>();
  // @Output() selectedProjectCountryIdEventEmitter: EventEmitter<any> = new EventEmitter<any>();
  // @Output() selectedRegionIdEventEmitter: EventEmitter<any> = new EventEmitter<any>();
  // @Output() selectedProjectIdEventEmitter: EventEmitter<any> = new EventEmitter<any>();
  // @Output() selectedUserIdEventEmitter: EventEmitter<any> = new EventEmitter<any>();
  // @Output() selectedUserRoleEventEmitter: EventEmitter<any> = new EventEmitter<any>();
  // @Output() selectedUnitIdEventEmitter: EventEmitter<any> = new EventEmitter<any>();
  subscriptions: Array<Subscription> = [];
  projectCountryFormControl = new FormControl();
  projectRegionFormControl = new FormControl();

  projectFormControl = new FormControl();

  userFormControl = new FormControl();


  showProjects: Observable<boolean>;
  showCountries: Observable<boolean>;
  showRegion: Observable<boolean>;
  showUsers: Observable<boolean>;

  constructor(
    public router: Router,
    public statisticsSelectionService: StatisticsSelectionService,
    public authorizationService: AuthorizationService,
  ) {
    this.showProjects = this.statisticsSelectionService.projects.pipe(
      map(projects => projects.length > 1)
    );

    this.showCountries = combineLatest(
      this.authorizationService.loggedInUserHasRightsNonLessThanAdminsManager(),
      this.statisticsSelectionService.countries
    ).pipe(
      map(([hasRightsNonLessThanAdmin, countries]) => {
          if (hasRightsNonLessThanAdmin) {
            return true;
          }
          return countries.length > 1;
        }
      )
    );

    this.showUsers = combineLatest(
      this.authorizationService.loggedInUserHasRightsNonLessThanAdminsManager(),
      this.statisticsSelectionService.users
    ).pipe(
      map(([hasRightsNonLessThanAdmin, users]) => {
          if (hasRightsNonLessThanAdmin) {
            return true;
          }
          return users.length > 1;
        }
      )
    );
  }

  ngOnInit() {
    this.subscriptions.push(
      this.projectFormControl.valueChanges.subscribe(
        value => {
          this.statisticsSelectionService.selectedProjectCountryCode.next(null);
          this.statisticsSelectionService.selectedProjectCountryId.next(null);
          this.statisticsSelectionService.selectedRegionId.next('all');
          this.statisticsSelectionService.selectedUserId.next('all');
          this.statisticsSelectionService.selectedProjectId.next(value);
        }
      )
    );
    this.subscriptions.push(
      this.projectCountryFormControl.valueChanges
        .pipe(
          withLatestFrom(this.statisticsSelectionService.countries)
        )
        .subscribe(
          ([projectCountryId, countries]) => {
            const country = countries.find(c => c.id === projectCountryId);
            this.statisticsSelectionService.selectedRegionId.next('all');
            this.statisticsSelectionService.selectedUserId.next('all');
            this.statisticsSelectionService.selectedProjectCountryCode.next(country.country_code);
            this.statisticsSelectionService.selectedProjectCountryId.next(projectCountryId);
          }
        )
    );
    this.subscriptions.push(
      this.projectRegionFormControl.valueChanges.subscribe(
        value => {
          this.statisticsSelectionService.selectedUserId.next('all');
          this.statisticsSelectionService.selectedRegionId.next(value);
        }
      )
    );
    this.subscriptions.push(
      this.userFormControl.valueChanges.subscribe(
        value => this.statisticsSelectionService.selectedUserId.next(value)
      )
    );
    this.subscriptions.push(
      this.statisticsSelectionService.selectedProjectId.subscribe(
        value => {
          // this.selectedProjectIdEventEmitter.emit(value);
          if (this.projectFormControl.value !== value) {
            this.projectFormControl.setValue(value, {emitEvent: false});
          }
        }
      )
    );
    this.subscriptions.push(
      this.statisticsSelectionService.selectedProjectCountryId.subscribe(
        value => {
          // this.selectedProjectCountryIdEventEmitter.emit(value);
          this.projectCountryFormControl.setValue(value, {emitEvent: false});
        }
      )
    );
    this.subscriptions.push(
      this.statisticsSelectionService.selectedRegionId.subscribe(
        value => {
          // this.selectedRegionIdEventEmitter.emit(value);
          this.projectRegionFormControl.setValue(value, {emitEvent: false});
        }
      )
    );
    this.subscriptions.push(
      this.statisticsSelectionService.selectedUserId.subscribe(
        value => {
          // this.selectedUserIdEventEmitter.emit(value);
          this.userFormControl.setValue(value, {emitEvent: false});
        }
      )
    );
    this.subscriptions.push(
      combineLatest(
        this.statisticsSelectionService.selectedProjectId,
        this.statisticsSelectionService.selectedProjectCountryId,
        this.statisticsSelectionService.selectedRegionId,
        this.statisticsSelectionService.selectedUserId,
        this.statisticsSelectionService.selectedUserRole,
      )
        .pipe(
          filter(
            ([selectedProjectId, selectedProjectCountryId, selectedRegionId, selectedUserId, selectedUserRole]) =>
              selectedProjectId !== null
              && selectedProjectCountryId !== null
              && selectedRegionId !== null
              && selectedUserId !== null
              && selectedUserRole !== null
          ),
          distinctUntilChanged(
            (a, b) => a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4]
          )
        )
        .subscribe(
          ([selectedProjectId, selectedProjectCountryId, selectedRegionId, selectedUserId, selectedUserRole]) => {
            const selection: StatisticSelectionData = {
              projectId: selectedProjectId,
              projectCountryId: selectedProjectCountryId,
              regionId: selectedRegionId,
              userId: selectedUserId,
              userRole: selectedUserRole,
            };
            this.selection.emit(selection);
          }
        )
    );
  }

  ngOnDestroy() {
    this.subscriptions.filter(s => !!s).forEach(s => s.unsubscribe());
    this.statisticsSelectionService.onDestroy();
  }

}
